import { Theme, useMediaQuery } from "@mui/material"
import { Link, Section } from "@tc/ui-dfe/components"
import { GoIcon } from "@tc/ui-dfe/icons"
import { Permission } from "@tc/ui-permission/components"
import { PERMISSION_CODE } from "@tc/ui-permission/utils"
import { ExportRequestsContentTable } from "../../ViewAllRequests/ExportRequestsContentTable"

export const RecentExportRequest = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))

  return (
    <Section
      title="Recent requests"
      disableGutters={mdDown}
      square
      actions={
        !mdDown && (
          <Permission
            allow={[
              PERMISSION_CODE.EXPORT_REQUEST_VIEW,
              PERMISSION_CODE.EXPORT_REQUEST_READ,
            ]}
          >
            <Link
              href="/requests"
              endIcon={
                <GoIcon
                  fontSize="small"
                  aria-hidden="true"
                  fill="forest.main"
                />
              }
              aria-label="View all requests"
              color="forest"
              bold
              disableGutters
            >
              View all requests
            </Link>
          </Permission>
        )
      }
      sx={{
        pt: 1.5,
      }}
    >
      <ExportRequestsContentTable isHomePage />
    </Section>
  )
}
